import React from 'react'
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material'

import { LookingForHousingStepProps } from '../types'

const LookingForHousingStep: React.FC<LookingForHousingStepProps> = ({ value, onChange, error }) => {
  const options = ['Yes', 'No']

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        Are you looking for next year housing?
      </Typography>

      <FormControl error={error}>
        <RadioGroup value={value} onChange={e => onChange(e.target.value)} className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} className="text-base" />
          ))}
        </RadioGroup>
        {error && <FormHelperText>This question is required</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default LookingForHousingStep
